import styled from "styled-components";
import SectionTitle from "../../components/SectionTitle";
import { fonts } from "src/constants";

export default styled(SectionTitle)`
    font-size: ${fonts.subtitle}px;
    line-height: 28px;
`;
